import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const FilterControls = ({ 
  activeFilter, 
  onFilterChange, 
  searchQuery, 
  onSearchChange
}) => {
  const filters = [
    { id: 'all', label: 'All Missions', icon: 'Grid3X3' },
    { id: 'beginner', label: 'Beginner', icon: 'Leaf' },
    { id: 'intermediate', label: 'Intermediate', icon: 'Zap' },
    { id: 'advanced', label: 'Advanced', icon: 'Flame' },
    { id: 'boss', label: 'Boss Missions', icon: 'Crown' },
    { id: 'completed', label: 'Completed', icon: 'CheckCircle' },
    { id: 'in-progress', label: 'In Progress', icon: 'PlayCircle' },
    { id: 'bookmarked', label: 'Bookmarked', icon: 'Bookmark' }
  ];

  return (
    <div className="bg-card border border-subtle rounded-lg p-4 space-y-4">
      {/* Search */}
      <div className="relative">
        <Input
          type="search"
          placeholder="Search missions..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e?.target?.value)}
          className="pl-10"
        />
        <Icon 
          name="Search" 
          size={18} 
          className="absolute left-3 top-1/2 transform -translate-y-1/2 text-muted-foreground" 
        />
      </div>
      {/* Filter Buttons */}
      <div className="space-y-3">
        <h4 className="text-sm font-medium text-foreground">Filter by Category</h4>
        <div className="flex flex-wrap gap-2">
          {filters?.map((filter) => (
            <Button
              key={filter?.id}
              variant={activeFilter === filter?.id ? "default" : "outline"}
              size="sm"
              iconName={filter?.icon}
              iconPosition="left"
              iconSize={14}
              onClick={() => onFilterChange(filter?.id)}
              className="text-xs"
            >
              {filter?.label}
            </Button>
          ))}
        </div>
      </div>
      {/* Quick Stats */}
      <div className="pt-3 border-t border-subtle">
        <div className="grid grid-cols-2 gap-4 text-center">
          <div>
            <div className="text-lg font-semibold text-primary">24</div>
            <div className="text-xs text-muted-foreground">Total Missions</div>
          </div>
          <div>
            <div className="text-lg font-semibold text-success">12</div>
            <div className="text-xs text-muted-foreground">Completed</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterControls;